import {StateSelector} from "@integration-frontends/common/utils/redux";
import {brandfolderAdapter} from "@integration-frontends/integration/core/application/common/entities-state/entities";
import {Brandfolder} from "@integration-frontends/integration/core/model";
import {EntityState} from "@reduxjs/toolkit";

export function createBrandfolderSelectors(stateSelector: StateSelector<EntityState<Brandfolder>>) {
  return brandfolderAdapter.getSelectors(stateSelector);
}
